import React from "react";

const DropDownMenuDivider = () => {
  return <div className="DropDownMenuDivider" />;
};

export { DropDownMenuDivider };
